import { Component, computed, inject } from '@angular/core';
import { TunnelCartService } from '../services/tunnel-cart.service';

/** Panneau des produits retenus dans la liste d'achat. */
@Component({
  selector: 'ng-casto-tunnel-cart-panel',
  templateUrl: './tunnel-cart-panel.component.html',
  styleUrls: ['./tunnel-cart-panel.component.scss'],
})
export class TunnelCartPanelComponent {
  protected readonly tunnelCartService = inject(TunnelCartService);

  /** Indique qu'une remise s'applique au total. */
  protected readonly displayDiscount = computed(
    () => this.tunnelCartService.totalWithDiscount() !== this.tunnelCartService.total()
  );
}
